import { Alert, Snackbar } from "@mui/material"
import React, { useEffect } from "react"
import { SnackbarType } from "../types/UI"

export function SnackbarWithText({
  text,
  open,
  severity,
  handleClose,
}: {
  text: string
  open: boolean
  severity: SnackbarType
  handleClose: () => void
}) {
  useEffect(() => {
    if (open) {
      setTimeout(() => handleClose(), 6000)
    }
  }, [open])

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        {text}
      </Alert>
    </Snackbar>
  )
}
